<template>
  <div>
    <b-loading :is-full-page="false" :active.sync="isLoading"/>
    <div class="buttons is-right">
      <button class="button" @click.prevent="onRefreshClick">
        <b-icon icon="refresh"/>
        <span>Refresh</span>
      </button>
    </div>
    <b-table
      :data="fcfList"
      hoverable
      striped
      
      paginated
      backend-pagination
      :total="total"
      :per-page="perPage"
      @page-change="onPageChange"
    >
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>No forms found</p>
            <p>See <router-link :to="{ name: 'list' }">all forms</router-link>
              or <router-link :to="{ name: 'main' }">create new</router-link>.
            </p>
          </div>
        </section>
      </template>

      <template slot-scope="props">

        <b-table-column field="job_number" label="Job Number" sortable>
          <router-link :to="{ name: 'show', params: { jobNumber: props.row.job_number }}">
            {{props.row.job_number}}
          </router-link>
        </b-table-column>

        <b-table-column field="client_name" label="Client" sortable>
          {{ props.row.client_name }}
        </b-table-column>

        <b-table-column field="status" label="Status" sortable>
          {{ $store.getters.getFormStatusName(props.row.status) }}
        </b-table-column>

        <b-table-column field="modified_date" label="Modified" sortable>
          {{ props.row.modified_date }}
        </b-table-column>

        <template v-if="$auth.check(['admin', 'superadmin']) && props.row.status === 1">
          <b-table-column label="Approve">
            <approve-button @approved="onApproved(props.row)"/>
          </b-table-column>
        </template>

      </template>
    </b-table>
  </div>
</template>

<script>
import ApproveButton from '@/components/ApproveButton'

export default {
  name: 'FcfList',
  components: {
    ApproveButton
  },
  data () {
    return {
      currentPage: 1,
      fcfList: [],
      total: null,
      perPage: 25,
      status: null,
      isLoading: false
    }
  },
  created () {
    this.status = this.$route.params.status
    this.getFormsList()
  },
  methods: {
    getFormsList () {
      this.isLoading = true
      const status = this.status
      const page = this.currentPage
      this.axios.get('fcf', { params: { page, status } })
        .then(response => {
          this.total = response.data.total
          this.fcfList = response.data.forms
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$toast.open({
            message: `Error: ${error.response.data.message}`,
            type: 'is-danger'
          })
        })
    },
    onPageChange (page) {
      this.currentPage = page
      this.getFormsList(page)
    },
    onRefreshClick () {
      this.getFormsList()
      this.$toast.open({
        message: 'Refreshed',
        type: 'is-info'
      })
    },
    async onApproved (rowObj) {
      try {
        const data = {
          formId: rowObj.id,
          formStatus: 10
        }
        await this.axios.put('fcf', data)
        rowObj.status = 10
        this.$toast.open({
          message: 'Form approved',
          type: 'is-success'
        })
      } catch (error) {
        this.$toast.open({
          message: 'Error while approving form',
          type: 'is-danger'
        })
      }
    }
  }
}
</script>

<style>

</style>
